<template>
  <div class="video-input">
    <div class="video-input__wrap">
      <h4 class="video-input__title">{{ computedTitle }}</h4>
      <form class="video-input__form">
        <div class="video-input__form-wrap">
          <Input class="video-input__input-wrap"
                 @onFocus="clearError"
                 @input="handleLink"
                 :value="videoLink"
                 :error="error"
                 :placeholder="$t('review_video_placeholder')" />
          <div class="video-input__btn-wrap">
            <Button class="video-input__btn"
                    type="plain-transparent"
                    @click.native="checkUrl"
                    :is-native-disabled="isValidateVideo"
                    :is-disabled="isValidateVideo">{{ $t('review_get_video') }}</Button>
            <Loader class="callback-form__loader"
                    v-if="isValidateVideo"
                    :is-loading="isValidateVideo"
                    :border-size="4"></Loader>
          </div>
        </div>
      </form>
    </div>
    <ul v-if="videosList.length" class="video-input__list video-list">
      <li class="video-list__item" v-for="video in videosList" :key="video.id">
        <img class="video-list__img" :src="video.thumbnail" :alt="video.title" />
        <span class="video-list__name block-ellipsis block-ellipsis-truncate">{{ video.title }}</span>
        <button class="video-list__remove" @click="removeVideo(video.id)"></button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import parseYoutubeUrl from '@/helpers/parseYoutubeUrl'
import Button from '@/components/inputs/Button'
import Input from '@/components/inputs/Input'
import Loader from '@/components/helpers/Loader'

export default {
  name: 'VideoInput',
  components: {
    Input,
    Button,
    Loader
  },
  data () {
    return {
      videoLink: '',
      error: '',
      videosList: [],
      isValidateVideo: false
    }
  },
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    videoIds () {
      return this.videosList.map(video => video.id)
    },
    computedTitle () {
      return this.isQuestions ? this.$t('questions.add_video') : this.$t('review_add_video')
    }
  },
  methods: {
    ...mapActions(['CHECK_YOUTUBE_URL']),
    handleLink (value) {
      this.videoLink = value
    },
    checkUrl () {
      const videoId = parseYoutubeUrl(this.videoLink)

      if (this.validateVideo(this.videoLink, videoId)) {
        this.isValidateVideo = true
        this.CHECK_YOUTUBE_URL(this.videoLink).then(res => {
          if (res.data.success && res.data.data) {
            this.videosList.push(res.data.data)
            this.clearVideoLink()
            this.clearError()
            this.emitVideoIds()
          } else {
            this.error = this.$t('review_video_error')
          }

          this.isValidateVideo = false
        })
      }
    },
    validateVideo (url, id) {
      const minUrlLength = 11

      if (!url) {
        this.error = this.$t('review_video_error_empty')
        return false
      } else if (!id || id.length < minUrlLength) {
        this.error = this.$t('review_video_error_not_valid')
        return false
      } else if (this.videoIds.includes(id)) {
        this.error = this.$t('review_video_error_duplicate')
        return false
      }

      return true
    },
    removeVideo (id) {
      this.videosList = this.videosList.filter(video => video.id !== id)
      this.emitVideoIds()
    },
    emitVideoIds () {
      this.$emit('changeVideos', this.videoIds)
    },
    clearVideoList () {
      this.videosList = []
    },
    clearError () {
      this.error = ''
    },
    clearVideoLink () {
      this.videoLink = ''
    },
    clearAll () {
      this.clearVideoList()
      this.clearVideoLink()
      this.clearError()
    }
  }
}
</script>

<style scoped lang="sass">

.video-input
  position: relative
  width: 100%
  padding: 25px 30px
  border-radius: 3px
  background-color: #f8f8f8

.video-input__form-wrap
  display: flex
  flex-flow: column
  margin: 20px 0 0

  +mmin($tablet)
    flex-flow: row nowrap
    align-items: flex-start

.video-input__input-wrap
  width: 100%
  min-height: 59px

  +mmin($tablet)
    margin: 0 24px 0 0

.video-input__text-wrap
  width: 100%

  +mmin($tablet)
    width: 65%

.video-input__btn-wrap
  position: relative
  flex-shrink: 0

.video-input__title
  margin: 0
  font-size: 18px
  font-weight: 500

.video-input__btn
  max-height: 40px

.video-list
  +list-unstyled
  width: 100%
  margin: 20px 0 0

.video-list__item
  display: flex
  align-items: center
  flex-flow: row nowrap
  width: 100%

  &:not(:first-child)
    margin: 15px 0 0

.video-list__img
  display: block
  width: 40px
  height: 40px
  object-fit: cover
  margin: 0 20px 0 0

.video-list__name
  width: 80%
  -webkit-box-orient: vertical
  -webkit-line-clamp: 2
  color: $placeholder-color

  +mmin($tablet)
    -webkit-line-clamp: 1

.video-list__remove
  cursor: pointer
  position: relative
  display: block
  width: 15px
  height: 15px
  opacity: .6
  border: 0
  padding: 0
  background-color: transparent
  margin: 0 0 0 auto

  &:hover
    opacity: 1

  &:before,
  &:after
    content: ''
    position: absolute
    top: 0
    left: 50%
    height: 15px
    width: 2px
    background-color: $text-color

  &:before
    transform: rotate(45deg)

  &:after
    transform: rotate(-45deg)
</style>
